export const actions = {
    getDimensions({ commit, state }, { src, $axios, $cookies }) {
        console.log('getDimensions');
        let width = 300;
        let height = 300;
        return [width, height];
    }
  };
  